import React, { useState } from "react";
import serviceone from "../../Images/epilipsyimage.jpg";
import ServiceSlider from "../../commanfile/ServiceSlider";
import ServiceButton from "../../commanfile/ServiceButton";
import PsynexaPost5 from "../../Images/epilpsy images4.png";
import Servicelist from "../../commanfile/Servicelist";
import Button from "../../commanfile/Button";
import { FaHandHoldingHeart } from "react-icons/fa6";
import Iconehelthpage from "../../commanfile/Iconehelthpage";

const Epilipsy = () => {
  const symtams1 = [
    "Sudden, uncontrollable jerking of arms or legs",
    "Staring spells or brief loss of awareness",
    "Temporary confusion or memory loss",
    "Loss of consciousness or awareness",
    "Strange sensations (smells, tastes, or feelings)",
  ];
  const symtams = [
    "Muscle stiffness or twitching",
    "Fear, anxiety",
    "Unusual behavior or repetitive movements",
    "Dizziness or vision changes",
    "Drooling or frothing at the mouth during a seizure",
  ];


const Data = [


    {
      question: "What is epilepsy?",
      answer: "Epilepsy is a chronic neurological disorder characterized by recurrent, unprovoked seizures caused by abnormal electrical activity in the brain. These seizures can affect awareness, behavior, sensations, or muscle control. Epilepsy affects people of all ages and may require lifelong management with medications or other treatments to control seizures"
    }, 
     {
      question: "What causes epilepsy?",
      answer: "Epilepsy can be caused by a variety of factors including genetic influences, brain injuries like trauma or stroke, brain tumors, infections such as meningitis or encephalitis, and developmental conditions. Damage before birth or exposure to toxins can also contribute. In many cases, the exact cause is unknown."

    }, 
     {
      question: "What are the common symptoms of epilepsy? ",
      answer: "Common symptoms of epilepsy include brief confusion, staring spells, uncontrolled jerking movements of the arms and legs, loss of consciousness or awareness, and sudden emotional changes like fear or anxiety. Symptoms vary depending on the type of seizure and which part of the brain is affected"

    }, 
     {
      question: "How is epilepsy diagnosed?",
      answer: "Epilepsy is diagnosed through a physical exam and medical history review, followed by tests such as an electroencephalogram (EEG) to measure brain electrical activity, MRI or CT scans to detect brain abnormalities, and blood tests. These help confirm the diagnosis and identify seizure types. Sometimes video monitoring and other specialized scans are used for detailed evaluation."

    }, 
    {
      question: "Can epilepsy be cured?",
      answer: "Epilepsy cannot be completely cured, but it can often be well controlled with treatment. About 70% of people become seizure-free using anti-seizure medications. For those who don't respond to medications, options include surgery, neurostimulation devices, and dietary therapies. Ongoing research explores advanced treatments like gene therapy and stem cells"
    }, 
    {
      question: "What treatment options are available for epilepsy?",
      answer: "Treatment options for epilepsy include anti-seizure medications, surgery to remove seizure-causing brain areas, neurostimulation devices like vagus nerve stimulation or responsive neurostimulation, and specialized diets like the ketogenic diet. Newer treatments involve deep brain stimulation, minimally invasive surgery, and transcranial magnetic stimulation."
    }, 
    {
      question: "Do all seizures look the same?",
      answer: "No, seizures do not all look the same. They vary widely, from brief staring spells or subtle twitching in one part of the body (focal seizures) to full-body stiffening and jerking movements with loss of consciousness (generalized seizures). Symptoms depend on the brain area affected."

    }, 
    {
      question: "Is epilepsy a lifelong condition?",
      answer: "Epilepsy can be lifelong for many people, but with proper treatment, about 60-70% become seizure-free. Some individuals may outgrow epilepsy, especially children. The prognosis varies based on factors like age at onset, type of epilepsy, and treatment response. Early and effective management improves outcomes"
    }, 
    {
      question: "Can people with epilepsy live normal lives?",
      answer: "Yes, people with epilepsy can live normal lives. With proper treatment, lifestyle adjustments, and seizure management, many lead full, active lives. Key strategies include taking medications as prescribed, avoiding seizure triggers, getting enough sleep, managing stress, and maintaining a healthy lifestyle"

    }, 
    {
      question: "What should I do if I see someone having a seizure?",
      answer: "If you see someone having a seizure, stay calm and keep them safe. Gently place something soft under their head, clear the area of sharp objects, and turn them on their side to keep their airway clear. Do not restrain them or put anything in their mouth. Call for emergency help if the seizure lasts more than 5 minutes, if another seizure follows immediately, or if the person is injured."

    }, 
    {
      question: "Is it safe for someone with epilepsy to drive?",
      answer: "Driving safety for people with epilepsy depends on seizure control. Most regions require individuals to be seizure-free for a period—usually 6 to 12 months—before they can legally drive. Compliance with medical advice and seizure management is essential. In some places, medical certification confirming stability is needed to obtain a license."
    }, 

    {
      question: "Can epilepsy affect children and older adults differently?",
      answer: "Yes, epilepsy can affect children and older adults differently. Children often have epilepsy linked to genetic or developmental causes and may outgrow it. Seizure types and symptoms can vary with age. Older adults are more likely to develop epilepsy due to strokes, tumors, or neurodegenerative diseases, with different management considerations."

    }, {
      question: "Does epilepsy affect mental health or memory?",
      answer: "Yes, epilepsy can affect mental health and memory. People with epilepsy have higher risks of anxiety, depression, and other psychiatric disorders due to brain changes and the stress of living with seizures. Memory or concentration difficulties may also occur, either related to seizures or medications"
    }, 
    {
      question: "Can lifestyle changes help manage epilepsy?",
      answer: "Yes, lifestyle changes can help manage epilepsy. Important steps include getting enough quality sleep, avoiding seizure triggers like stress, alcohol, and certain drugs, eating a balanced diet, exercising regularly, and managing stress. Keeping a seizure diary and following medication schedules also aid in better control."

    }, 
    {
      question: "Are there any risks or side effects from epilepsy medications?",
      answer: "Epilepsy medications can cause side effects such as tiredness, dizziness, stomach upset, blurred vision, and cognitive issues like memory or concentration problems. Some may experience mood changes, allergic reactions, or more serious effects like liver problems or blood disorders. Always discuss risks and benefits with a doctor."

    }, 
    {
      question: "Is epilepsy hereditary?",
      answer: "Epilepsy can have a hereditary component. Certain types of epilepsy are linked to genetic mutations that can be inherited from parents. Children with a family history of epilepsy are at higher risk, though not all epilepsy is inherited; many cases result from spontaneous genetic changes or other factors. Genetics play a significant role in some epilepsy forms but do not guarantee the condition"

    }, 
    {
      question: "Can stress or lack of sleep trigger seizures?",
      answer: "Yes, both stress and lack of sleep can trigger seizures in people with epilepsy. Stress releases hormones that affect the brain and can lower the seizure threshold. Lack of sleep increases seizure risk by impacting brain activity and overall health. Managing stress and getting enough rest help reduce seizure frequency."
    }, 
   

  ]
   const [isOpen, setisOpen] = useState("null")
  
    const togglefaqs = (index) => {
      setisOpen(isOpen === index ? null : index)
    }

  return (
    <>
      <div className="max-w-[1456px] mt-2 mx-auto ">
        <div className=" shadow-xl pb-8">
          <ServiceSlider
            classname={"flex flex-wrap sm:flex-nowrap px-3 flex-row-reverse "}
            title={"Epilepsy"}
            content={
              "Epilepsy is not a limitation—it is a condition that can be managed with the right care and support. "}
            maincontent={
              "Living with epilepsy may bring challenges, but it does not define who you are or what you can achieve. With proper treatment, awareness, and understanding from society, people with epilepsy can live full, independent, and meaningful lives. Breaking the stigma begins with acceptance and compassion—because epilepsy is just one part of a person’s journey, not their identity."}
            buttonname={"Explore Treatment Option "}
            imgs={serviceone}
          />
        </div>
        <div className="py-16  ">
          <div className="text-center border-b-4">
            <p className="font-roboto text-3xl capitalize line-clamp-5 p-2">
              Here’s how clinical epilepsy may present itself..These are

            </p>
            <div className="flex-none md:flex flex-row-reverse items-center mx-auto justify-around py-6 ">
              <div className=" pt-2">
                <img
                  src={PsynexaPost5}
                  className="border-black rounded-full h-[400px] w-[400px] border-3 mx-auto"
                />
              </div>
              <div>
                <div className="lg:flex p-5 pl-10  justify-between mx-auto md:gap-6">
                  <div className=" ">
                    <Servicelist Symtams={symtams} />
                  </div>
                  <div className="">
                    <Servicelist Symtams={symtams1} />
                  </div>
                </div>
                <div className="mx-auto ">
                  <Button
                    className={
                      "text-black hover:text-white font-roboto text-[20px] text-center items-center bg-[#50b1a4] p-1 rounded-full h-[40px] w-[200px]"
                    }
                    btnName={"Get Appointment"}
                    link={"/ContactUs"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mx-auto py-8">
          <div className="flex-none justify-around pt-5 p-1 items-center">
            <div className="w-full  ">
              <p className=" flex gap-2 font-roboto text-3xl text-[#469B8F] uppercase font-semibold">
                <FaHandHoldingHeart />
              Guided by Expertise, Driven by Compassion
              </p>

              <p className=" mx-auto text-justify text-lg py-3 px-5">
                At Psynexa, we specialize in diagnosing and treating epilepsy
                and seizure-related conditions to help individuals gain greater
                stability and control in daily life.
              </p>
              <p className=" mx-auto text-justify text-lg py-2 px-5">
                Our expert team manages Seizures, caused by sudden brain
                activity disruptions and Pseudo Seizures (PNES) which mimic
                seizures but arise from psychological stress. We also care for
                patients with Conversion Disorder where emotional distress
                causes physical symptoms like paralysis or fainting.
              </p>
              <p className=" mx-auto text-justify text-lg py-2 px-5">
                We use advanced diagnostics and compassionate psychological
                support to create tailored treatment plans. These may include
                medications, psychotherapy, and stress management, aimed at
                reducing symptoms and improving emotional strength.
              </p>
            </div>

          </div>
        </div>
        <div className="bg-[#e7f2f2] px-10">
         <Iconehelthpage/>
        </div>

 <div className="mx-auto md:pl-[40px] md:pr-[40px] p-2 pt-10">
          <div className="mx-auto">
            <p className="text-2xl font-bold text-center font-roboto">FAQs</p>
          </div>
          <div className="space-y-4 mt-4">
            {Data.map((faq, index) => (
              <div key={index} className="border border-gray-200 w-[100%] mx-auto rounded-lg">
                <button
                  onClick={() => togglefaqs(index)}
                  className="w-full text-left px-4 py-3 flex justify-between items-center focus:outline-none"
                >
                  <span className="font-medium font-roboto">{faq.question}</span>
                  <span>{isOpen === index ? '-' : '+'}</span>
                </button>
                {isOpen === index && (
                  <div className="px-4 py-2 font-roboto text-justify text-gray-600">{faq.answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>

      </div>
    </>
  );
};

export default Epilipsy;
